<ul class="header-tabs hide-sm">
	<li [ngClass]="{'active': selectedOrder === allProductsValue}">
		<a class="cursor--force-hand" (click)="unSelectOrder()"
		   i18n="All products link@@all.products.link">All products</a>
	</li>

	<!-- If no orders, start new order -->
	@if (showOrderSwitcher()) {
	<li class="header-orderswitcher active">
		<div class="custom-select">
			<select id="orderswitcher"
			        class="theme-primary-text-color"
			        [ngModel]="selectedOrder"
			        (ngModelChange)="changeOrder($event)">

				@for (order of activeOrders; track order) {
				<option [ngValue]="order" data-private>
					@if (order.deliveryDate) {
					<span render-day-of-week-abbr [day]="order.deliveryDate.shippingDayName"></span>
					}
					{{order.shipmentDate | customDate:'dd MMMM'}} - {{order.deliveryAddressName}} ({{order.shipToCode}})
				</option>
				}

				<option [ngValue]="'new'" i18n="Start new order link text@@start.new.order.button">
					Start new order
				</option>
			</select>
		</div>

		@if (activeOrders) {
		<label class="header-orderswitcher_count" for="orderswitcher">
			({{activeOrders.length}})
		</label>
		}
	</li>
	}

	@if (!showOrderSwitcher() && firstActiveOrder != null) {
	<li class="theme-primary-highlight-color">
		<a class="header-link" (click)="changeOrder(firstActiveOrder)" data-private>
			@if (firstActiveOrder.deliveryDate) {
			<span render-day-of-week-abbr [day]="firstActiveOrder.deliveryDate.shippingDayName"></span>
			}
			{{firstActiveOrder.shipmentDate | customDate:'dd MMMM'}} -
			{{firstActiveOrder.deliveryAddressName}}
			({{firstActiveOrder.shipToCode}})
		</a>
	</li>
	}

	@if (!showOrderSwitcher() && firstActiveOrder == null) {
	<li>
		<a (click)="startNewOrder()" class="header-link" i18n="Start new order link text@@start.new.order.button">
			Start new order
		</a>
	</li>
	}
</ul>

<div class="custom-select header-tabs--select hide-lg hide-md visible-sm">
	<select id="orderswitcherResponsive" [ngModel]="selectedOrder" (ngModelChange)="changeOrder($event)">
		<option [ngValue]="allProductsValue" i18n="All products link text@@all.products.link">
			All products
		</option>

		@for (order of activeOrders; track trackByOrder($index, order)) {
		<option [ngValue]="order" data-private>
			{{order.shipmentDate | customDate:'EEE dd MMMM'}} - {{order.deliveryAddressName}} ({{order.shipToCode}})
		</option>
		}

		<option [ngValue]="newProductValue" i18n="Start new order link text@@start.new.order.button">
			Start new order
		</option>
	</select>
</div>
